import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/business-disciplines/new/loading';

export const Route = createFileRoute('/_private/settings/business-disciplines/new')({
  component: Loading,
});
